/**
 * KAN-679: which of the learner's certificates the course summary's
 * "View Certificate" button opens. The learner's certificate list spans every
 * course they have finished, so match on the course; if the course somehow
 * carries more than one, open the most recently issued. A row without an id
 * cannot be opened (/certificates/undefined), so it never counts as a match.
 */
export interface CourseCertificateRef {
  id: string;
  courseId: string;
  issuedAt: string;
}

export function findCertificateForCourse<T extends CourseCertificateRef>(
  certificates: readonly T[] | null | undefined,
  courseId: string | null | undefined
): T | null {
  if (!courseId || !certificates) return null;
  return certificates
    .filter((c) => c.courseId === courseId && !!c.id)
    .reduce<T | null>(
      (latest, c) => (!latest || Date.parse(c.issuedAt) > Date.parse(latest.issuedAt) ? c : latest),
      null
    );
}
